import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Prompt, Redirect } from 'react-router';
import { Button, Col, FormGroup, Label, Row } from 'reactstrap';
import { UserStore } from 'src/Stores/User/UserStore';
import { ICategory } from '../../../../Interfaces/AdminInterface';
import ButtonRow from '../../../ButtonRow';
import { EButton, EInput } from '../../../EInput';



@inject('stores')
@observer
class AdminCategoryDetails extends React.Component {

    public props: any;
    public category: ICategory = new ICategory();
    public categoryDisposer: any;
    public adminStore: any;
    public MessageStore: any;
    private UserStore: UserStore;

    public state = {
        category: this.category,
        categoryId: '',
        isDirty: false,
        redirect: false,
    };

    constructor(props: any) {
        super(props);

        this.adminStore = this.props.stores.AdminStore;
        this.MessageStore = this.props.stores.MessageStore;
        this.UserStore = this.props.stores.UserStore;
        this.handleChange = this.handleChange.bind(this);
        this.handleSaveCategory = this.handleSaveCategory.bind(this);
        this.removeCategory = this.removeCategory.bind(this);
    }

    public componentDidMount() {
        this.createDisposers();

        this.setState({
            categoryId: this.props.match.params.id,
        }, () => {
            if ( this.state.categoryId !== 'new' ) {
                this.adminStore.getCategory(this.props.match.params.id);
            }
        });
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }

    public createDisposers() {
        this.categoryDisposer = intercept(this.adminStore, 'category', (change: any) => {
            this.setState({
                category: change.newValue
            });

            return change;
        });
    }

    public clearDisposers() {
        this.categoryDisposer();
    }

    public handleChange(event: any) {
        const category = this.state.category;

        category[event.target.name] = event.target.value;

        this.setState({
            category,
            isDirty: true
        });
    }

    public handleSaveCategory() {
        this.adminStore.saveCategory(this.state.category)
            .then(
                (data: any) => {
                    this.setState({
                        redirect: true
                    });
                    let message = 'Changes have been saved';

                    if ( this.state.categoryId === 'new' ) {
                        message = 'Category has been saved and created';
                    }
                    this.MessageStore.addMessage(
                        message,
                        'success'
                    );
                },
                (error: any) => {
                    this.MessageStore.addMessage(
                        error.toString(),
                        'danger'
                    );
                }
            );
    }

    public removeCategory() {
        this.adminStore.deleteCategory(this.state.category)
            .then(
                (data: any) => {
                    this.setState({
                        redirect: true
                    });

                    this.MessageStore.addMessage(
                        'Category Successfully Deleted',
                        'success'
                    );
                }
            );
    }

    public render() {
        return(
            this.state.redirect ? (
                <Redirect to="/admin/categories" />
            ) : (
                <div>
                    <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                    <Row className="header">
                        <Col md="12">
                            {this.state.categoryId === 'new' ? (
                                <h2 className="float-left">Add New Category</h2>
                            ) : (
                                <h2 className="float-left">Category Detail for {this.state.category.name}</h2>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <FormGroup className="required">
                                <Label>Name</Label>
                                <EInput
                                    type="text"
                                    name="name"
                                    required={true}
                                    value={this.state.category.name}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Description</Label>
                                <EInput
                                    type="textarea"
                                    name="description"
                                    value={this.state.category.description}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    {
                            (this.state.categoryId === 'new' ?
                            this.UserStore.hasPermission('Permissions.Admin.Categories.Create')
                            :
                            this.UserStore.hasPermission('Permissions.Admin.Categories.Update'))
                            &&
                        <ButtonRow>
                            <Button color="danger" onClick={this.removeCategory}>Delete Category</Button>
                            <EButton color="primary" onClick={this.handleSaveCategory}>Save Category</EButton>
                        </ButtonRow>
                    }
                </div>
            )
        );
    }
}

export default AdminCategoryDetails;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Categories/AdminCategoryDetails.tsx